import React, { useEffect } from 'react'
import { motion } from "framer-motion";
import { ImageBuffer } from '../..'
import { img2 } from '../../../assets'
import { CallRounded } from '@mui/icons-material';

import './hero.css'

const Hero = () => {
    
  return (
    <>
        <section id="hero" className="hero-wrapper">
            <main className="hero-container">
                <div className="hero-container-left">
                    <div className="hero-btn-cover">
                        <div className="hero-btn-main">
                            <span className="hero-btn-animate"></span>
                            <span className="hero-btn-color"></span>
                        </div>
                        <span>Strengthening Health With Care You Can Trust.</span>
                    </div>
                    <div className=''>
                        <motion.h1 
                            initial={{opacity: 0, y: 40}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.6, delay: 0.8}}
                            viewport={{once: true}}
                            className="hero-title-text">
                                A1Care Licensed Home
                            <span className="hero-sub-text">
                                Health Agency.
                            </span>
                        </motion.h1>
                        <motion.p 
                            initial={{opacity: 0, y: 30}} 
                            whileInView={{opacity: 1, y: 0}} 
                            transition={{duration: 0.5, delay: 1}}
                            viewport={{once: true}}
                            className='hero-title-description'>At A1Care Licensed Home Health Agency, Our experienced professionals deliver high-quality, reliable care services designed to improve health outcomes across a wide range of healthcare environments.
                        </motion.p>
                    </div>
                    <div className="hero-text-btr-cover">
                        <a href='#about' className="hero-text-btr-1">
                            <span className="text-btr-main">Get Started</span>
                            <span className="text-btr-sub">Get Started</span>
                        </a>
                        <a href="tel:+4694340425" className="hero-call-to-action-link">
                            <CallRounded className="hero-call-to-action-btn" />
                            Call Today: 
                            <span className='hero-call-to-action-link-title'>+1 4694340425</span>
                        </a>
                    </div>
                </div>
                <div className='hero-image-wrapper'>
                    <div className='hero-image'>
                        <ImageBuffer src={img2} alt='hero-img' className='hero-image-right' />
                    </div>
                </div>
            </main>

            <div className=''>
                <div className=''>

                </div>
            </div>
        </section>
    </>
  )
}

export default Hero